exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".copyright--Oxtt7 {\n  border-top: 2px solid #fff;\n  text-align: center;\n  padding-top: 40px;\n  padding-bottom: 40px;\n}\n\n", ""]);

// exports
exports.locals = {
	"copyright": "copyright--Oxtt7"
};